import { useSyncExternalStore } from 'react';
import { i18n } from '../i18n';

export function useI18n() {
  const subscribe = (callback) => {
    i18n.on('languageChanged', callback);
    return () => i18n.off('languageChanged', callback);
  };

  const getSnapshot = () => i18n.language;

  useSyncExternalStore(subscribe, getSnapshot);

  return {
    t: (key, options) => i18n.t(key, options),
    locale: i18n.language,
    setLocale: (newLocale) => {
      i18n.changeLanguage(newLocale);
      localStorage.setItem('language', newLocale);
    },
  };
}
